// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wE1yI","right":"styles_right__33ork"};